import { TextField, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { IEtablissement, setFilteredEtablissement } from "../../store/siteWebSlice";




const SearchBar = () => {

  //Redux
  const dispatch = useDispatch();
  const { etablissements } = useSelector((state: IReduxState) => state.siteWeb);

  //hooks
  const theme = useTheme();
  const endesssousDeLg = useMediaQuery(theme.breakpoints.down("lg"));
  const [search, setSearch] = React.useState("");


  //Filtrer la liste
  const filterFunction = () => {
    if (search.length === 0) {
      dispatch(setFilteredEtablissement([...etablissements]));
    } else {
      const result: any = etablissements.filter(
        (item: IEtablissement, index: number) => {
          const value: any = `${item.libEtab}`;
          return value.toLowerCase().includes(search.toLowerCase());
        }
      );
      dispatch(setFilteredEtablissement(result));
    }
  };

  React.useEffect(() => {
    filterFunction();
  }, [search]);



  return (
    <Box>
      <TextField
        style={{ marginTop: endesssousDeLg ? 15 : 0 }}
        size="small"
        fullWidth
        label="Rechercher..."
        onChange={(e) => setSearch(e.target.value)}
      />
    </Box>
  );
};
export default SearchBar;
